export const config = {
  debounceTime: 600,
  services: {
    hotjar: {
      id: '3240389'
    },
    jsonbin: {
      root: 'https://api.jsonbin.io/v3'
    }
  }
}
